import { Skeleton, Box } from '@mui/material'

const SkeletonPart = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '0.625rem',
    }}
  >
    <Box>
      <Skeleton variant="text" width={100} sx={{ display: 'inline-block', marginBottom: '0.3125rem' }} />
      <Skeleton variant="text" width={200} sx={{ marginBottom: '0.3125rem' }} />
    </Box>
  </Box>
)

const CompanyInfoSkeleton = () => (
  <>
    <div style={{ display: 'flex', gap: '10rem' }}>
      <div>
        <SkeletonPart />
        <SkeletonPart />
      </div>
      <div>
        <SkeletonPart />
        <SkeletonPart />
      </div>
    </div>
    <SkeletonPart />
    <Skeleton variant="rectangular" width="18.75rem" height="2.8125rem" />
  </>
)

export default CompanyInfoSkeleton
